const Category=[
    "Business",
    "Entertainment",
    "General",
    "Sports",
    "technology"

]
export default Category